import { atom, useAtom } from "jotai";

export const tradeSelectedPriceAtom = atom("");

export function useTradeSelectedPrice() {
	const [selectedPrice, setSelectedPrice] = useAtom(tradeSelectedPriceAtom);

	return {
		selectedPrice,
		setSelectedPrice,
	};
}
